// extracted by mini-css-extract-plugin
export default {"wrapper":"HeaderOnly_wrapper__zu5RO"};